import React from "react";
import { useSelector } from "react-redux";
import RootState from "../../redux/states/root.state";
import LoginForm from "./components/LoginForm";
import AuthLayout from "./components/AuthLayout";

const LoginPage: React.FC = () => {
  const { loading } = useSelector((state: RootState) => state.user);

  return (
    <AuthLayout title="Log in" subtitle="Sign in to manage your spas.">
      {loading ? (
        <div className="auth-loading">
          <span className="spinner" role="progressbar" aria-label="Loading" />
        </div>
      ) : (
        <LoginForm />
      )}
    </AuthLayout>
  );
};

export default LoginPage;
